'use server';

import { headers, cookies } from 'next/headers';


/**
 * @description Get server request headers. To be used in data fetching functions inside server components only.
 * @returns {Promise<Record<string, string>>} Server request headers.
 *
 * @example
 * const serverHeaders = await getServerReqHeaders(locale);
 * const data = await fetcher('/v1/header-info', locale, { headers: serverHeaders });
 */
export const getServerReqHeaders = async (): Promise<Record<string, string>> => {
  const reqHeaders = await headers();
  const reqCookies = await cookies();

  return {
    'User-Agent': reqHeaders.get('user-agent') ?? '',
    Cookie: reqCookies.toString(),
  };
};
